import { Resolve } from '@angular/router';
import { Injectable } from '@angular/core';

import { catchError, first, mergeMap, tap } from 'rxjs/operators';
import { ApiService } from '../services/api.service';
import { Observable, of } from 'rxjs';
import { select } from '@angular-redux/store';
import { Themes } from '../core/themes/themes.model';
import { ThemesActionService } from '../core/themes/themes.action';

@Injectable()
export class ThemesResolver implements Resolve<Themes[]> {
  @select(['theme', 'list'])
  themesList$: Observable<Themes[]>;
  isThemesInRedux = false;

  constructor(private service: ApiService,
              private themeAction: ThemesActionService) {}

  resolve() {
    return this.themesList$.pipe(
      first(),
      mergeMap((list) => {
        if (list.length > 0) {
          this.isThemesInRedux = true;
          return of(list);
        }
        return this.service.getThemes().pipe(first());
      }),
      tap((list: any) => {
        if (!this.isThemesInRedux) {
          this.themeAction.themesList(Themes.fromArray(list));
        }
      }),
      catchError((err) => {
        console.error('Non è stato possibile recuperare la lista di percorsi tematici');
        return of(err);
      })
    );
  }
}
